import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { ReportsService } from "../reports.service";
import { IRecentSavedReportModel } from "./recent-saved-report.model";
import { Response } from "@angular/http";

@Component({
    selector: 'recent-saved-reports',
    templateUrl: 'recent-saved-reports.component.html'
})

export class RecentSavedReportsComponent implements OnInit {
    data: IRecentSavedReportModel[];
    showOverlay: boolean = false;
    @Output() clickedRecentReport: EventEmitter<any>  = new EventEmitter<Event>();

    constructor(private reportsService: ReportsService) {
     }

    ngOnInit() {
        this.showOverlay = true;
        this.reportsService.getLatestSavedReports().subscribe(
            (res: Response) => { this.data = <IRecentSavedReportModel[]>res.json() },
            () => { },
            () => { this.showOverlay = false; }
        )
    }

    onClick(report: IRecentSavedReportModel) {
        this.clickedRecentReport.emit(report);
    }
}


// WEBPACK FOOTER //
// ./src/app/reports/recent-saved-reports/recent-saved-reports.component.ts